import { Component, OnInit, OnDestroy } from '@angular/core';
import { Photo } from './photo';
import { PhotoService } from './photo.service';

declare var $: any;
declare var myInterval: any;

@Component({
  selector: 'app-evuslider',
  templateUrl: './evuslider.component.html',
  styleUrls: ['./evuslider.component.scss'],
  providers: [PhotoService]
})
export class EvusliderComponent implements OnInit {

  photos: Photo[];
  constructor(private photoService: PhotoService) { }

  ngOnInit() {
    this.photos = this.photoService.getPhotos();
    this.evuSlider("start"); // Slider baslayalim.
  }

  ngOnDestroy() {
    this.evuSlider("stop"); // Cikista slideri durduralim.
  }

  evuSlider($event) {
    $(function () {
      // Toplam Slider Sayisi
      var sliderCount = $("div#homeImageSlider > ul > li").length - 1;
      var currentSlider = 0;

      if ($event == "start") {
        this.myInterval = setInterval(mycode, 3000);
        console.log("start");
      } else if ($event == "stop") {
        clearInterval(this.myInterval);
        console.log("stop");
      }

      function mycode() {
        if (currentSlider == sliderCount) {
          // Console
          console.log("Son slayt.");
          // Slide reset
          currentSlider = currentSlider = 0;
          $("div#homeImageSlider > ul > li").eq(sliderCount).fadeOut(500);
          $("div#homeImageSlider > ul > li").eq(currentSlider).fadeIn(500);
        } else {
          // Console 
          console.log(currentSlider);
          $("div#homeImageSlider > ul > li").eq(currentSlider).fadeOut(2000);
          $("div#homeImageSlider > ul > li").eq((currentSlider + 1)).fadeIn(1000);
          // Next Slider
          currentSlider = currentSlider + 1;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/evuslider/evuslider.component.ts